(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('GrowthDialogController', GrowthDialogController);

    GrowthDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Growth', 'GrowthCustomService'];

    function GrowthDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Growth, GrowthCustomService) {
        var vm = this;

        vm.growth = entity;
        vm.clear = clear;
        vm.save = save;
        vm.growths = Growth.query();
        vm.growthsParent = [];
        GrowthCustomService.returnParentGrowths().then(function (data) {
            vm.growthsParent = data.data;
        }, function (error) {
            vm.growthsParent = [];
        });

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.growth.id !== null) {
                Growth.update(vm.growth, onSaveSuccess, onSaveError);
            } else {
                Growth.save(vm.growth, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('ccsTrApp:growthUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
